export default "__VITE_ASSET__73afcfab__"